import { createFileRoute } from "@tanstack/react-router";
import { OnboardingPage } from "../pages/OnboardingPage.tsx";

export const Route = createFileRoute("/onboarding")({
  component: OnboardingPage,
});
